import { IGiangVienBanActionTypes } from "../../action-types/category/IGiangVienBanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IGiangVienBanReducer } from "../../reducer-model/category/IGiangVienBanReducer";

const initState: IGiangVienBanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  giangVienBans: [],
};
export const giangVienBanReducer = (
  state: IGiangVienBanReducer = initState,
  action: IGiangVienBanActionTypes
): IGiangVienBanReducer => {
  switch (action.type) {
    case "GIANG_VIEN_BAN_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "GIANG_VIEN_BAN_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, giangVienBans: action.payload };
    case "GIANG_VIEN_BAN_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "GIANG_VIEN_BAN_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, giangVienBanEditing: action.payload };
    case "GIANG_VIEN_BAN_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "GIANG_VIEN_BAN_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "GIANG_VIEN_BAN_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "GIANG_VIEN_BAN_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "GIANG_VIEN_BAN_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "GIANG_VIEN_BAN_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "GIANG_VIEN_BAN_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
